import { render, staticRenderFns } from "./AccountSettingsPasswordValidation.vue?vue&type=template&id=a803da0e&scoped=true"
import script from "./AccountSettingsPasswordValidation.vue?vue&type=script&lang=js"
export * from "./AccountSettingsPasswordValidation.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsPasswordValidation.vue?vue&type=style&index=0&id=a803da0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a803da0e",
  null
  
)

export default component.exports